// extracted by mini-css-extract-plugin
export var wordContainer = "_nz-0";